import { Allocation, SerializedComponent } from '../machines';

export const mergeComponentsWithAllocations = (
  components: SerializedComponent[],
  allocations: Allocation[] = []
) =>
  components.map((component) => {
    const { memo, quantity } =
      allocations.find((a) => a.id === component.id) || {};

    if (memo) {
      component.memo = memo;
    }

    if (typeof quantity === 'number' || typeof quantity === 'string') {
      component.allocatedQuantity = quantity;
    }

    return component;
  });
